import { PuffLoader } from 'react-spinners'

const LoadingView = () => (
  <div className="h-full w-full fixed left-0 top-0 bg-black/50 transition-[opacity] duration-500 flex justify-center items-center">
    <PuffLoader color="blue" />
  </div>
)

export default LoadingView
